import './App.css';
import Slider from './Slider';
import Nav from './Nav';
import PageContentContainer from './PageContentContainer';
import ScrollProgress from './ScrollProgress';
import BackToTop from './BackToTop';

function App() {
  return (
    <div className='app-shell'>
      <div id='app'>
        <ScrollProgress />
        <header>
          <Slider />
          <Nav />
        </header>
        <PageContentContainer />
        <BackToTop />
      </div>
    </div>
  );
}

export default App;
